import React from "react";

export default function StatusQuo() {
	return (
		<div>
			<div className="alt-font">
				<h2 id="status_quo">ESG status quo</h2>
				<p>
					Unser Beratungsangebot "ESG status quo" zielt darauf ab, Unternehmen
					bei der Überprüfung und Verbesserung ihrer Nachhaltigkeit zu
					unterstützen. Durch eine gründliche Analyse des Assets und Portfolios
					werden mögliche ESG-Risiken identifiziert und bewertet.
				</p>
				<p>
					Die Wesentlichkeitsanalyse untersucht, welche Aspekte der
					Nachhaltigkeit für das Unternehmen am wichtigsten sind und inwieweit
					sie in den Geschäftsprozessen berücksichtigt werden. Die 360°-Analyse
					bietet einen umfassenden Überblick über die Nachhaltigkeit des
					Unternehmens, während die Carbon-Footprint-Analyse den CO2-Fußabdruck
					des Unternehmens quantifiziert.
				</p>
				<p>
					Ein weiterer Schwerpunkt liegt auf der Green/ESG Due Diligence. Hier
					gehen wir ins Detail und untersuchen, ob das Unternehmen seinen
					ESG-Verpflichtungen nachkommt. Wir prüfen die Relevanz und
					Verbindlichkeit von Nachhaltigkeitszielen und erstellen eine Übersicht
					über die Umsetzung von ESG-Maßnahmen.
				</p>
				<p>
					Zudem beleuchten wir den aktuellen Stand der Kreislaufwirtschaft und
					erstellen eine Analyse des ESG-Wahrnehmungsstands durch die
					Stakeholder. Auf dieser Basis können wir dann individuelle
					Handlungsempfehlungen für eine verbesserte Nachhaltigkeit im
					Unternehmen geben.
				</p>
				<ul className="typeset-u-list">
					<li>Asset- und&nbsp;Portfolioanalyse​</li>
					<li>ESG-Risikoanalyse​</li>
					<li>Wesentlichkeitsanalyse​</li>
					<li>360°Analyse​</li>
					<li>Carbon Footprint Analyse​</li>
					<li>Green/ESG&nbsp;Due Diligence</li>
					<li>Circular&nbsp;Economy Status Quo</li>
					<li>ESG-Wahrnehmungsanalyse&nbsp;(Stakeholder)</li>
				</ul>
			</div>
		</div>
	);
}
